import { CentralIconBase, type CentralIconBaseProps } from "./CentralIconBase";
import {
  centralIcons,
  centralIconsMetadata,
  type CentralIconName,
  type CentralIconJoin,
  type CentralIconFill,
  type CentralIconRadius,
  type CentralIconStroke,
  type CentralIconImportName,
} from "./icons";
import React, { type FC, memo } from "react";

export { type CentralIconBaseProps };

export type CentralIconProps = CentralIconBaseProps & {
  join: CentralIconJoin;
  fill: CentralIconFill;
  radius: CentralIconRadius;
  stroke: CentralIconStroke;
  name: CentralIconName;
};

export const CentralIcon: FC<CentralIconProps> = memo(
  ({ name, join, fill, radius, stroke, children, ...props }) => {
    const iconKey: CentralIconImportName = `${join}-${fill}-radius-${radius}-stroke-${stroke}/${name}`;
    return (
      <CentralIconBase ariaLabel={centralIconsMetadata[name].title} {...props}>
        {children}
        <g dangerouslySetInnerHTML={{ __html: centralIcons[iconKey] }} />
      </CentralIconBase>
    );
  },
);

CentralIcon.displayName = "CentralIcon";

export default CentralIcon;
